import { type TFunction } from "i18next";

const GJU_DETAILS: Partial<Record<GjuContactRecordType, string>> = {
  student: "gju:student_history.tab",
  alumni: "gju:student_history.tab",
  "practice-partner": "gju:partner_profile.tab",
  "academic-partner": "gju:partner_profile.tab",
};

export const gjuRecordType = (contact: ContactFull) =>
  contact.attrs.addfields?.["record-type"] as GjuContactRecordType | undefined;

export const isGjuManagedContact = (contact: ContactFull) => !!GJU_DETAILS[gjuRecordType(contact) || "contact-person"];

export const gjuDetailsLabel = (contact: ContactFull) =>
  GJU_DETAILS[gjuRecordType(contact) || "contact-person"] || "contacts:show.questionnaire";

export const GJU_STATUS: Record<string, { label: string; variant: "success" | "warning" | "secondary" }> = {
  "Deutschlandjahr aktiv": { label: "gju:contacts.statuses.german_year_active", variant: "success" },
  "Partnerschaft aktiv": { label: "gju:contacts.statuses.partnership_active", variant: "success" },
  Praktikumssuche: { label: "gju:contacts.statuses.internship_search", variant: "warning" },
  Vertragspruefung: { label: "gju:contacts.statuses.contract_review", variant: "warning" },
  Vertragsprüfung: { label: "gju:contacts.statuses.contract_review", variant: "warning" },
  "Fachliche Abstimmung": { label: "gju:contacts.statuses.technical_alignment", variant: "warning" },
  Erstkontakt: { label: "gju:contacts.statuses.initial_contact", variant: "secondary" },
  Alumni: { label: "gju:contacts.statuses.alumni", variant: "secondary" },
};

export function gjuRecordTypeLabel(recordType: GjuContactRecordType | undefined, statusName: string | undefined) {
  if (statusName !== "Partnerschaft aktiv" && recordType === "practice-partner") {
    return "gju:contacts.record_types.practice-partner-lead";
  }
  if (statusName !== "Partnerschaft aktiv" && recordType === "academic-partner") {
    return "gju:contacts.record_types.academic-partner-lead";
  }

  return `gju:contacts.record_types.${recordType || "person"}`;
}

export function gjuContactSummary(addfields: GjuContactAddfields, t: TFunction) {
  const summary: string[] = [];

  if (addfields["record-type"] === "student" || addfields["record-type"] === "alumni") {
    if (addfields["study-program"]) summary.push(addfields["study-program"]);
  } else if (addfields["record-type"] === "practice-partner") {
    if (addfields.industry) summary.push(addfields.industry);
    if (addfields["partner-category"]) {
      summary.push(t("gju:contacts.category", { value: addfields["partner-category"] }));
    }

    if (addfields["internship-capacity"] || addfields["internship-capacity"] === 0) {
      summary.push(t("gju:contacts.places", { count: Number(addfields["internship-capacity"]) }));
    }
  } else if (addfields["record-type"] === "academic-partner" && addfields["study-programs"]?.length) {
    summary.push(addfields["study-programs"].join(", "));
  }

  return summary;
}
